import React, { useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Pesado/actions'
import { Card } from 'react-bootstrap'
import { Button, Dialog } from '@material-ui/core'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_PESO_DESTARE } from '../../../../config/forms'
import ConfiguracionDestare from './ConfiguracionDestare'
import DialogView from '../../../Dialogos/DialogView'
import OpcionesAccionPesadoDestare from './OpcionesAccionPesadoDestare'
import OpcionesConfiguracionDestare from './OpcionesConfiguracionDestare'

const selector = formValueSelector(FORM_PESO_DESTARE)

function ConfiguracionPesadoDestare (props) {
  const { cpe, forzarBarreras, equilibrio, pesadoAuto, roles } = props
  const [open, setOpen] = useState(false)

  const openDialogConfiguracion = () => {
    const {
      change: formChange,
      urlDestare,
      pesoMaximo,
      pesoMaximoAdvertencia,
      pesoMinimo,
      pesoMinimoAdvertencia
    } = props
    formChange('urlDestare', urlDestare && urlDestare)
    formChange('pesoMaximo', pesoMaximo && pesoMaximo)
    formChange('pesoMaximoAdvertencia', pesoMaximoAdvertencia && pesoMaximoAdvertencia)
    formChange('pesoMinimo', pesoMinimo && pesoMinimo)
    formChange('pesoMinimoAdvertencia', pesoMinimoAdvertencia && pesoMinimoAdvertencia)
    setOpen(true)
  }

  const closeDialog = () => {
    setOpen(false)
  }

  const updateParametros = () => {
    const { url, pMax, pMaxAdvertencia, pMin, pMinAdvertencia } = props
    props.updateUrlDestare(url)
    props.updatePesoMaximoDestare(parseInt(pMax))
    props.updatePesoMaximoAdvertenciaDestare(parseInt(pMaxAdvertencia))
    props.updatePesoMinimoDestare(parseInt(pMin))
    props.updatePesoMinimoAdvertenciaDestare(parseInt(pMinAdvertencia))
    setOpen(false)
  }

  const abrirBarreraEntrada = () => {
    props.abrirBarreraEntradaDestare()
  }

  const abrirBarreraSalida = () => {
    props.abrirBarreraSalidaDestare()
  }

  const cerrarBarreraEntrada = () => {
    props.cerrarBarreraEntradaDestare()
  }

  const cerrarBarreraSalida = () => {
    props.cerrarBarreraSalidaDestare()
  }

  const updateModoPesado = () => {
    const { pesadoAuto, balanza } = props
    if (pesadoAuto) {
      props.updateModoPesajeDestare('manual', balanza)
    } else {
      props.updateModoPesajeDestare('auto', balanza)
    }
  }

  const updateCicloBarreras = () => {
    const { modoBarreras, balanza } = props
    if (modoBarreras === 'auto') {
      props.updateCicloBarreras('manual', balanza)
      props.desactivarBarreraAutomaticoDestare()
    } else {
      props.updateCicloBarreras('auto', balanza)
      props.activarBarreraAutomaticoDestare()
    }
  }

  const updateForzarBarreras = () => {
    const { forzarBarreras } = props
    if (forzarBarreras === 'si') {
      props.updateForzarBarreras('no')
      props.anularForzarBarreraDestare()
    } else {
      props.updateForzarBarreras('si')
      props.forzarBarreraDestare()
    }
  }

  const updateEnclavamiento = () => {
    const { equilibrio } = props
    if (equilibrio) {
      props.updateEnclavamiento(0)
    } else {
      props.updateEnclavamiento(1)
    }
  }

  const updateEnclavamientoBarreras = () => {
    const { enclavamientoBarreras } = props
    if (enclavamientoBarreras === 0) {
      props.actualizarEnclavamientoBarrerasDestare(1)
    } else {
      props.actualizarEnclavamientoBarrerasDestare(0)
    }
    // toast.info('El balancero deberá actualizar la interfaz para aplicar los cambios.')
  }

  const rol = roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return (
    <div className='container-configuracion-destare'>
      <Dialog
        open={open}
        onClose={closeDialog}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={updateParametros}
          cancelCallback={closeDialog}
          title='Configuración de pesado destare'
          content={<OpcionesConfiguracionDestare />}
        />
      </Dialog>

      <Card className='bg-white rounded card-configuracion-destare'>

        <Card.Title className='title-card-configuracion'>
          <h5>Configuración de barreras</h5>
        </Card.Title>
        <div className='container-acciones-config'>
          <Button
            className='btn-accion-config'
            onClick={abrirBarreraEntrada}
            variant='contained'
            color='primary'
            style={{ margin: '8px' }}
          >
              Abrir barrera entrada
          </Button>
          <Button
            className='btn-accion-config'
            onClick={abrirBarreraSalida}
            variant='contained'
            color='primary'
            style={{ margin: '8px' }}
          >
              Abrir barrera salida
          </Button>
          <Button
            className='btn-accion-config'
            onClick={cerrarBarreraEntrada}
            variant='contained'
            color='primary'
            style={{ margin: '8px' }}
          >
              Cerrar barrera entrada
          </Button>
          <Button
            className='btn-accion-config'
            onClick={cerrarBarreraSalida}
            variant='contained'
            color='primary'
            style={{ margin: '8px' }}
          >
              Cerrar barrera salida
          </Button>
        </div>
      </Card>

      <ConfiguracionDestare
        updateModoPesado={updateModoPesado}
        updateCicloBarreras={updateCicloBarreras}
        updateForzarBarreras={updateForzarBarreras}
        updateEnclavamiento={updateEnclavamiento}
        enclavamientoBarreras={props.enclavamientoBarreras}
        updateEnclavamientoBarreras={updateEnclavamientoBarreras}
        rolAutorizado={rolAutorizado}
        pesadoAuto={pesadoAuto}
        equilibrio={equilibrio}
        modoBarreras={props.modoBarreras}
        forzarBarreras={forzarBarreras}
        openDialogConfiguracion={openDialogConfiguracion}
      />

      <OpcionesAccionPesadoDestare
        cpe={cpe}
        rolAutorizado={rolAutorizado}
        printerDestare={props.printerDestare}
        onPrinterChange={props.onPrinterChange}
        pesadoAuto={pesadoAuto}
        pesarEnCabina={props.pesarEnCabina}
        updateRepeso={props.updateRepeso}
        repeso={props.repesoDestare}
        reimprimirTicket={props.reimprimirTicket}
      />

    </div>
  )
}

const mapStateToProps = (state) => ({
  cpe: state.pesado.cpePesadoDestare,
  enclavamientoBarreras: state.pesado.enclavamientoBarrerasDestare,
  equilibrio: state.pesado.enclavamientoDestare,
  modoBarreras: state.pesado.modoBarrerasDestare,
  forzarBarreras: state.pesado.forzarBarrerasDestare,
  printerDestare: state.pesado.printerDestare,
  urlDestare: state.pesado.urlDestare,
  url: selector(state, 'urlDestare'),
  pesoMaximo: state.pesado.pesoMaximoDestare,
  pMax: selector(state, 'pesoMaximo'),
  pesoMaximoAdvertencia: state.pesado.pesoMaximoAdvertenciaDestare,
  pMaxAdvertencia: selector(state, 'pesoMaximoAdvertencia'),
  pesoMinimo: state.pesado.pesoMinimoDestare,
  pMin: selector(state, 'pesoMinimo'),
  pesoMinimoAdvertencia: state.pesado.pesoMinimoAdvertenciaDestare,
  pMinAdvertencia: selector(state, 'pesoMinimoAdvertencia'),
  repesoDestare: state.pesado.repesoDestare,
  roles: state.auth.roles
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_DESTARE,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(ConfiguracionPesadoDestare))
